/* eslint-disable  */
import { checkPermissions } from '#/permissions';
import { roles } from '#/constants';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import ApartmentIcon from '@material-ui/icons/Apartment';
import GavelIcon from '@material-ui/icons/Gavel';
import DescriptionIcon from '@material-ui/icons/Description';
import FolderIcon from '@material-ui/icons/Folder';
import PersonIcon from '@material-ui/icons/Person';
import AssignmentIcon from '@material-ui/icons/Assignment';
import WorkIcon from '@material-ui/icons/Work';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import ApiIcon from '@mui/icons-material/Api';

export const navRoutes = [
    {
        title: 'Users',
        href: '/users',
        rules: [roles.admin],
        icon: < PersonIcon htmlColor='white' />
    },
    // add pricing analyst to /properties
    //add picing analyst to/ orders
    //  add back as role in users
    {
        title: 'Properties',
        href: '/properties',
        rules: [roles.admin, roles.pricing_analyst, roles.user, roles.regional_manager_admin, roles.legal, roles.legal_admin, roles.executive_assistant],
        icon: <ApartmentIcon htmlColor='white' />
    },
    {
        title: 'Departments',
        href: '/departments',
        rules: [roles.admin],
        icon: <PeopleAltIcon htmlColor='white' />
    },
    {
        title: 'Employees',
        href: '/employees',
        rules: [roles.admin, roles.user, roles.regional_manager_admin, roles.executive_assistant],
        icon: <PeopleAltIcon htmlColor='white' />
    },
    {
        title: 'Evaluations',
        href: '/evaluations',
        rules: [roles.admin, roles.regional_manager_admin, roles.executive_assistant],
        icon: < AssignmentIcon htmlColor='white' />
    },
    {
        title: 'Job Titles',
        href: '/titles',
        rules: [roles.admin],
        icon: < WorkIcon htmlColor='white' />
    },
    {
        title: 'Notaries',
        href: '/notaries',
        rules: [roles.admin, roles.legal_admin],
        icon: < PermContactCalendarIcon htmlColor='white' />
    },
    {
        title: 'Lawyers',
        href: '/lawyers',
        rules: [roles.admin, roles.legal_admin],
        icon: <GavelIcon htmlColor='white' />
    },
    {
        title: 'Documents',
        href: '/documents',
        rules: [roles.admin, roles.legal_admin],
        icon: <DescriptionIcon htmlColor='white' />
    },
    {
        title: 'Orders',
        href: 'false',
        rules: [roles.admin, roles.regional_manager_admin, roles.user, roles.pricing_analyst],
        children: [
            {
                title: 'Config',
                href: '/orders/config',
                rules: [roles.admin]
            },
            {
                title: 'Report',
                href: '/properties/orders',
                rules: [roles.admin, roles.regional_manager_admin, roles.user, roles.pricing_analyst]
            },
            {
                title: 'MissingEntrata',
                href: '/properties/not_in_entrata',
                rules: [roles.admin, roles.regional_manager_admin, roles.pricing_analyst, roles.user,]
            }
        ],
        icon: < FolderIcon htmlColor='white' />
    },
    {
        title: 'Unit Types',
        href: '/unit-types',
        rules: [roles.admin, roles.pricing_analyst],
        icon: <ApartmentIcon htmlColor='white' />
    },
    // {
    //     title: 'Unit Types',
    //     href: '/unit-types',
    //     rules: [roles.admin],
    //     icon: <ApartmentIcon htmlColor='white' />
    // },
    {
        title: 'Portfolio',
        href: false,
        rules: [roles.admin, roles.executive_assistant, roles.legal_admin, roles.pricing_analyst],
        children: [
            {
                title: 'Counts',
                href: '/portfolio/counts',
                rules: [roles.admin, roles.executive_assistant, roles.pricing_analyst]
            },
            {
                title: 'Evictions',
                href: '/portfolio/evictions',
                rules: [roles.admin, roles.executive_assistant, roles.legal_admin, roles.pricing_analyst]
            },
            {
                title: 'Available',
                href: '/portfolio/available',
                rules: [roles.admin, roles.executive_assistant, roles.pricing_analyst]
            },
            // {
            //     title: 'All Pricing',
            //     href: '/portfolio/allPricing',
            //     rules: [roles.admin, roles.executive_assistant]
            // },
            {
                title: 'Flagged',
                href: '/portfolio/flagged',
                rules: [roles.admin, roles.executive_assistant, roles.pricing_analyst]
            },
            {
                title: 'Financial',
                href: '/portfolio/financial',
                rules: [roles.admin]
            },
            {
                title: 'Unit Summary',
                href: '/portfolio/unit-summary',
                rules: [roles.admin, roles.executive_assistant, roles.pricing_analyst]
            },
            {
                title: 'Employee Discounts',
                href: '/portfolio/employee-discounts',
                rules: [roles.admin]
            },
            {
                title: 'Lease Trade Out',
                href: '/portfolio/lease-trade-out',
                rules: [roles.admin, roles.pricing_analyst]
            },
            {
                title: 'Whips',
                href: '/portfolio/whips',
                rules: [roles.admin, roles.executive_assistant, roles.legal_admin, roles.pricing_analyst]
            }
        ],
        icon: < FolderIcon htmlColor='white' />
    },
    {
        title: 'Scripts',
        href: '/scripts',
        rules: [roles.admin, roles.pricing_analyst],
        icon: <DescriptionIcon htmlColor='white' />
    },
    {
        title: 'Reports Version',
        href: '/reports-version',
        rules: [roles.admin, roles.pricing_analyst],
        icon: <ApiIcon htmlColor='white' />
    }

    // {
    //     title: 'Employees',
    //     href: false,
    //     rules: ['admin', /manager/],
    //     children: [
    //         {
    //             title: 'Manage Employees',
    //             href: '/employees',
    //             rules: ['admin', /manager/]
    //         },
    //         {
    //             title: 'Manage Job Titles',
    //             href: '/titles',
    //             rules: ['admin']
    //         },
    //         {
    //             title: 'Manage Evals',
    //             href: '/evals',
    //             rules: ['admin']
    //         }
    //     ],
    //     icon: <PeopleAltIcon />
    // },
    // {
    //     title: 'Units',
    //     href: false,
    //     rules: ['admin'],
    //     children: [
    //         {
    //             title: 'Manage Units',
    //             href: '/units',
    //             rules: ['admin']
    //         },
    //         {
    //             title: 'Unit Pricing and Availabilities',
    //             href: '/units/pricing',
    //             rules: ['admin']
    //         }
    //     ],
    //     icon: 'table'
    // }

];

const filterRoutes = (routes, roles) => routes.filter(route => checkPermissions((route.rules || []), roles));

export const routeEntries = roles => filterRoutes(navRoutes, roles)
    .map(route => {

        if (route.children) {

            route.children = filterRoutes(route.children, roles);
        }

        return route;
    });
